import Application from "../../Application";
import { IReportService } from "../../service/report/ReportService";
import Report5Presenter, {
  IReport5Presenter
} from "../../presenter/report/Report5Presenter";

export default class ShowReport5PageInteractor {
  private application: Application;
  private output?: IReport5Presenter;
  private reportService: IReportService;

  constructor(application, reportService) {
    this.application = application;
    this.reportService = reportService;
  }

  execute() {
    this.output = Report5Presenter({
      application: this.application,
      initialState: {
        report5ReportingPeriodList: [],
        report5CurrentReportingPeriod: undefined,
        report5: undefined
      }
    });

    this.reportService
      .getReportingPeriodList()
      .then(this.output && this.output.loadReportingPeriodList);

    return this.output;
  }
}
